import React, { useState } from "react";
import l from "components/util/l";
import { toPermissionKey, getKeyError } from "components/util/helpers/user/permissions/PermissionField.lib.customPermission";

// Opens inside the permissions <form> (the seed Modal has no portal), so it holds no <form> of its
// own: its buttons are type="button" and Enter is caught before it submits the whole editor.
const CustomPermissionForm = ({
  permission,
  takenKeys,
  onSave,
  onClose
}) => {

  const isEdit = Boolean(permission.originalKey);
  const [label, setLabel] = useState(permission.label);
  const [group, setGroup] = useState(permission.group);
  const [typedKey, setTypedKey] = useState(permission.originalKey || "");
  // A new permission's key follows its name until the key is typed by hand.
  const [isKeyTouched, setIsKeyTouched] = useState(isEdit);

  const key = toPermissionKey(isKeyTouched ? typedKey : label);
  const keyError = getKeyError(key, permission.originalKey, takenKeys);
  const isRenamed = isEdit && key !== permission.originalKey;
  const isInvalid = !label.trim() || !key || Boolean(keyError);

  const onSubmit = () => {
    if (isInvalid) return;
    onSave({ key, label: label.trim(), group: group.trim() });
  };

  const onKeyDown = (event) => {
    if (event.key !== "Enter") return;
    event.preventDefault();
    onSubmit();
  };

  const onChangeKey = (event) => {
    setIsKeyTouched(true);
    setTypedKey(event.target.value);
  };

  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-header-title">
          {isEdit ? l("Editar permiso%VG375") : l("Nuevo permiso personalizado%PA892")}
        </h4>
      </div>

      <div className="card-body">

        <div className="form-group">
          <label htmlFor="permission-label">{l("Nombre%GA074")}</label>
          <input
            id="permission-label"
            type="text"
            className="form-control"
            value={label}
            autoFocus
            onChange={(event) => setLabel(event.target.value)}
            onKeyDown={onKeyDown}
          />
        </div>

        <div className="form-group">
          <label htmlFor="permission-group">{l("Grupo (opcional)%VG374")}</label>
          <input
            id="permission-group"
            type="text"
            className="form-control"
            placeholder={l("Permisos propios%VG373")}
            value={group}
            onChange={(event) => setGroup(event.target.value)}
            onKeyDown={onKeyDown}
          />
        </div>

        <div className="form-group">
          <label htmlFor="permission-key">{l("Clave%VG376")}</label>
          <input
            id="permission-key"
            type="text"
            className="form-control"
            value={isKeyTouched ? typedKey : key}
            onChange={onChangeKey}
            onKeyDown={onKeyDown}
          />
          {keyError &&
            <small className="text-danger d-block mt-1">{keyError}</small>}
          {!keyError && isKeyTouched && key && key !== typedKey &&
            <small className="text-muted d-block mt-1">{key}</small>}
          {isRenamed &&
            <small className="text-warning d-block mt-1">
              {l("Las vistas y procesos que revisen la clave anterior dejarán de reconocerla%VG377")}
            </small>}
        </div>

        <div className="d-flex justify-content-end">
          <button type="button" className="btn btn-link mr-2" onClick={onClose}>
            {l("Cancelar%GA009")}
          </button>
          <button type="button" className="btn btn-primary" disabled={isInvalid} onClick={onSubmit}>
            {l("Guardar%GA023")}
          </button>
        </div>

      </div>
    </div>
  );

};

export default CustomPermissionForm;
